import { useVariantFeatureFlag } from "../../utils/hooks/useFeatureFlag";
import { FeatureFlags } from "../../utils/launchDarklyUtils";

const KNOWN_VARIANTS = ["popup", "note", "off"];

/**
 * A/B test variants for the Carrier Screen attachment on the Clinical Indication
 * step:
 * - "popup": modal shown when clicking NEXT
 * - "note": red note below the Aneuploidy NIPT section prompting the
 *   provider to select the Carrier Screen box above
 * - "off": no attachment
 * Any other value (flag unset, LaunchDarkly unavailable) falls back to
 * "off" so the attachment stays dark until the flag serves a real variant.
 */
export const useCarrierScreenAttachmentVariant = (): {
  variant: string;
  loading: boolean;
} => {
  const { variant, loading } = useVariantFeatureFlag(
    FeatureFlags.CarrierScreenAttachmentVariant,
  );
  return {
    variant: KNOWN_VARIANTS.includes(variant) ? variant : "off",
    loading,
  };
};
